export default __webpack_public_path__ + "static/media/volkihar-slide-2-large.b9fb01f1.jpg";